import $http from './http'
import config from './config'
export default {
  name: 'hotel',
  CheckRepeatOrder(data) {
    return $http.post(this.getUrl('/HotelOrder/CheckRepeatOrder'), data, {
        failTips: false
    });
  },
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getCreateOrder(data) {
    return $http.post(this.getUrl(`/HotelOrder/CreateOrder`), data);
  },
  OrderDetails(UniqueID) {
    return $http.get(this.getUrl(`/HotelOrder/OrderDetails?UniqueID=${UniqueID}`));
  },
  RefundJudge(UniqueID) {
    return $http.get(this.getUrl(`/HotelOrder/RefundJudge?UniqueID=${UniqueID}`));
  },
  CreateAmend(amend) {
    return $http.post(this.getUrl(`/HotelOrder/CreateAmend`), amend)
  },
  OrderCancel(id) {
    return $http.get(this.getUrl(`/HotelOrder/OrderCancel?UniqueID=${id}`));
  },
  OrderSubmit(UniqueID) {
    return $http.get(this.getUrl(`/HotelOrder/OrderSubmit/${UniqueID}`));
  },
  UpdateOrderStatus(id) {
    return $http.get(this.getUrl(`/HotelOrder/UpdateOrderStatus?UniqueID=${id}`));
  },
  OrderRefund(data) {
    return $http.post(this.getUrl('/HotelOrder/OrderRefund'), data);
  },
  CreateOrderByPreference(data) {
    return $http.post(this.getUrl('/HotelOrder/CreateOrderByPreference'), data);
  },
  SearchOrders(id) {
    return $http.get(this.getUrl(`/HotelOrder/SearchOrders?UniqueID=${id}`));
  },
  OrderRefundCancel(id) {
    return $http.get(this.getUrl(`/HotelOrder/OrderRefundCancel?UniqueID=${id}`));
  },
  getRefundPrice(id) {
    return $http.get(this.getUrl(`/hotelorder/RefundPrice?id=${id}`));
  }
}



// WEBPACK FOOTER //
// ./src/apis/hotelApi.js